import React from 'react'
import { Outlet } from 'react-router-dom'
import NavBar from './Component/NavBar'
import "./css/root.css"
import {Footer} from "./Default"

const Root = () => {
  return (
    <div className='mainContainer bg-[#280274] w-[100vw]'>
      <NavBar></NavBar>
      <Outlet></Outlet>
      <Footer></Footer>
    </div>
  )
}

export default Root
